module.exports = __webpack_public_path__ + "img/voucher_20.e750e1e2.jpg";